import styled from 'styled-components';

export const LogoutAgency = styled.div`
  float: right;
  margin-left: 10px;
  cursor: pointer;
  border: 1px solid #999999;
  border-radius: 20px;
  padding: 3px 10px;
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    opacity: 0.7;
  }
`;

export const BoxNames = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: 10px;
`;

export const NameAgency = styled.div`
  color: #0185d4;
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const NameBox = styled.div`
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
